import { InputTable, InputColumnTableProps, ETypeOfNotification, setNotification } from "medere-ui-framework";
import LocationActionMenu, { LocationActionItem } from "../../components/LocationActionMenu";
import { Totem } from "../../../../../interface/interface";
import { saveTotem } from "../../../../../servicesHooks/Location/useLocationConfigService";
import { useDispatch } from "react-redux";
import useResizeListener from "../../../../../hooks/useResizeListener";
import LocationMobileActionMenu, { LocationMobileActionItem } from "../../components/LocationMobileActionMenu";

interface Props {
    totems: Totem[];
    onChange: (newTotems: Totem[]) => void;
    onEdit: (totem: Totem) => void;
    onDelete: (totem: Totem, _idx: number) => void;
}

export function TotemTable({ totems, onChange, onEdit, onDelete }: Props) {
    const isMobile = useResizeListener(768);
    const dispatch = useDispatch()

    const toggleActive = (totemIndex: number) => { //Acceso rapido a activar/desactivar un totem para no requerir editar
        const updatedTotems = [...totems];
        const updatedItem = { ...updatedTotems[totemIndex], active: !updatedTotems[totemIndex].active };

        saveTotem(updatedItem).then(() => { //No inactiva consultorios/puestos de atencion, pues lo pueden usar otros llamadores y totems. Solo se desactivará la pantalla del totem elegido
            updatedTotems[totemIndex] = updatedItem
            onChange(updatedTotems);
        }).catch((err) => {
            console.error(err)
            dispatch(setNotification({ title: "Ocurrió un error", desc: `No se pudo editar el tótem`, icon: 'pi-times', typeOfNotification: ETypeOfNotification.ERROR }));
        })
    };

    const columns: InputColumnTableProps<Totem>[] = [
        {
            header: "Nombre",
            className: "w-1/4",
            body: (row) => (row.totemapptitle),
        },
        {
            header: "ID",
            className: "w-1/12",
            body: (row) => (row.totemid),
        },
        {
            header: "Descripción",
            className: "w-1/2",
            body: (row) => (row.description),
        },{
            header: "Imprime",
            className: "w-1/12",
            body: (row) => (<span>{row.active ? "Sí" : "No"}</span>),
        },
        {
            header: "Estado",
            className: "w-1/12",
            body: (row) => (<span>{row.active ? "Activo" : "Inactivo"}</span>),
        },
        {
            header: "",
            className: "w-1/12",
            body: (item, _idx) => {
                const menuItems: LocationActionItem[] = [
                    {
                        label: "Editar",
                        icon: "pi pi-file-edit",
                        action: () => onEdit(item),
                    },
                    {
                        label: item.active ? "Desactivar" : "Activar",
                        icon: item.active ? "pi pi-minus-circle" : "pi pi-check-circle",
                        action: () => toggleActive(_idx),
                    },
                    {
                        label: "Eliminar",
                        icon: "pi pi-trash",
                        action: () => onDelete(item, _idx),
                    },
                ];
                return (
                    <div className="flex justify-content-end">
                        <LocationActionMenu items={menuItems} ariaLabel="Opciones del tótem" buttonId="buttonmenuitemid" />
                    </div>
                );
            },
        },
    ];

    function formatCardValue(value: string | null | undefined, emptyText = "Sin datos") {
        const normalized = String(value ?? "").trim();
        return normalized !== "" ? normalized : emptyText;
    }

    //border-divider hace que se vea el divider en la tabla
    if (isMobile) {
        return (
            <div className="location-mobile-card-list">
                {(totems ?? []).map((item, index) => {
                    const menuItems: LocationMobileActionItem[] = [
                        {
                            label: "Editar",
                            icon: "pi pi-file-edit",
                            action: () => onEdit(item),
                        },
                        {
                            label: item.active ? "Desactivar" : "Activar",
                            icon: item.active ? "pi pi-minus-circle" : "pi pi-check-circle",
                            action: () => toggleActive(index),
                        },
                        {
                            label: "Eliminar",
                            icon: "pi pi-trash",
                            action: () => onDelete(item, index),
                        },
                    ];

                    return (
                        <article key={`location-totem-${item.totem}-${index}`} className="location-mobile-card">
                            <div className="location-mobile-card-header">
                                <h4 className="location-mobile-card-title">{formatCardValue(item.totemapptitle, "Sin nombre")}</h4>
                                <LocationMobileActionMenu items={menuItems} ariaLabel="Opciones del tótem" />
                            </div>
                            <div className="location-mobile-card-row">
                                <span className="location-mobile-card-key">ID</span>
                                <span className="location-mobile-card-value">{item.totemid || "-"}</span>
                            </div>
                            <div className="location-mobile-card-row">
                                <span className="location-mobile-card-key">Descripción</span>
                                <span className="location-mobile-card-value">{formatCardValue(item.description)}</span>
                            </div>
                            <div className="location-mobile-card-row">
                                <span className="location-mobile-card-key">Imprime</span>
                                <span className="location-mobile-card-value">{item.printerenabled ? "Sí" : "No"}</span>
                            </div>
                            <div className="location-mobile-card-row">
                                <span className="location-mobile-card-key">Estado</span>
                                <span className="location-mobile-card-value">{item.active ? "Activo" : "Inactivo"}</span>
                            </div>
                        </article>
                    );
                })}
                {(totems ?? []).length === 0 && (
                    <p className="location-mobile-empty">No hay tótems cargados.</p>
                )}
            </div>
        );
    }

    return (
        <div>
            <InputTable
                columnGap={4}
                headerDivClassName="font-semibold bg-bluegray-50"
                dividerClassName="my-1 border-divider"
                buttonColumnWidth={3}
                items={totems}
                columns={columns}
                divider
            />
        </div>
    );
}


